import React from 'react';
import './ChartFieldSection.scss';
import { IMessageProps, Message } from '../../Core';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import classNames from 'classnames';
import { toTitleCase } from '../../../Lib/String';
import SVG from 'react-inlinesvg';
import { isNil } from 'ramda';

interface IChartFieldSection {
  chart?: any;
  heading?: string;
  messages?: IMessageProps[];
  visible?: boolean;
  wide?: boolean;
  height?: number;
}

const ChartFieldSectionBase: React.FC<IChartFieldSection> = ({
  chart,
  heading,
  messages,
  visible = true,
  wide = false,
  height = 500,
}) => {
  if (heading) {
    heading = toTitleCase(heading);
  }

  /*
   * viewBox should match svg width height in CSS and also in RenderSvg in QN
   * based on option 1 - https://css-tricks.com/scale-svg/
   * if we want to go more fancy - https://www.sarasoueidan.com/blog/svg-coordinate-systems/
   */
  const svg = `<svg viewBox="0 0 ${wide ? 768 : 500} ${height}">${chart}</svg>`;

  return !visible ? null : (
    <section className="ChartSection">
      {heading && <h2 className="ChartSection-Heading">{heading}</h2>}
      {!isNil(chart) && (
        <div className="ChartSection-Content">
          <div className={classNames({ 'ChartSection-Chart-wide': wide }, 'ChartSection-Chart')}>
            <SVG src={`data:image/svg+xml;utf8,${encodeURIComponent(svg)}`} uniquifyIDs={true} />
          </div>
        </div>
      )}

      {messages && messages.length > 0 && (
        <div className="ChartSection-Messages">
          {messages.map((props, i) => (
            <Message key={i} {...props} />
          ))}
        </div>
      )}
    </section>
  );
};

const ChartFieldSection = withInjectedProps(ChartFieldSectionBase);

export { ChartFieldSection };
export default ChartFieldSection;
